import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/form/contactus/Slice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import { Badge, Button } from "react-bootstrap";
import View_Modal from "../../../common-components/common_Modal/view_Modal/View_Modal";
import View_Share_Booking_Modal from "../../../common-components/common_Modal/View_Share_Booking_Modal/View_Share_Booking_Modal";
import View_Share_Taxi_Rating_Model from "../../../common-components/common_Modal/View_Share_Taxi_Rating_Model/View_Share_Taxi_Rating_Model";
import { formatDate } from "../../../../utils/common";
import { DOWNLOAD_EXCEL } from "../../../../utils/Methods";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import View_img_Modal from "../../../common-components/common_Modal/view_img_Modal/View_img_Modal";

const Booking = () => {
  const dispatch = useDispatch();
  const [image, setImage] = React.useState("");
  const [modalImageShow, setModalImageShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [detailModalShow, setDetailModalShow] = useState(false);
  const [ratingShow, setRatingShow] = useState(false);
  const [dropdetails, setDropDetails] = useState("");
  const [bookingdetails, setBookingDetails] = useState("");
  const [rating, setRating] = useState([]);

  const url = new URL(window.location);

  const {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    from,
    setFrom,
    to,
    setTo,
    fetch,
    deleteData,
    toggleStatus,
    driverName,
    setDriverName,
    setBookingType,
    setBookingId,
    bookingType,
    driverEmail,
    setDriverEmail,
  } = IndexUse();

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);
  useEffect(() => {
    if (country?.data?.data) {
      const newIds = country?.data?.data?.map((d) => d.id);
      setAllChecked(newIds);
    }
  }, [country?.data]);

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleDelete = async (id) => {
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    await fetch();
    // if (success) setSuccess(true);
    // else setErr(true);
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  const HandleDownload = async () => {
    // if (selectAllChecked.length == 0) {
    //   alert("Please Select Atleast One Record");
    // } else {
    try {
      await DOWNLOAD_EXCEL(
        "/admin/booking/download",
        selectAllChecked,
        "Booking List",
      );
    } catch (error) {
      console.error("Error:", error);
    }
    // }
  };

  return (
    <>
      <section className="content_body section_box">
        <div className="top_title_sec">
          <div className="forms_section">
            <div className="row align-items-end">
              <div className="col-md-12">
                <Section_title title="Share Bookings " alltotal="" />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">
                  Filter by Driver Contact Number
                </label>
                <Form.Control
                  type="text"
                  placeholder="Enter Driver Contact Number"
                  value={contact_no}
                  onChange={(e) => setcontact_no(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by Driver Name</label>
                <Form.Control
                  type="text"
                  placeholder="Enter Driver Name"
                  value={driverName}
                  onChange={(e) => setDriverName(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by Driver Email</label>
                <Form.Control
                  type="text"
                  placeholder="Enter Driver Email"
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by From Date</label>
                <Form.Control
                  type="date"
                  placeholder="Enter From"
                  value={from}
                  onChange={(e) => {
                    setFrom(e.target.value);
                    handlePageChange(1);
                    setTo("");
                  }}
                />
              </div>
              <div className="col-md-4 mb-3 form-group">
                <label className="form-label">Filter by To Date</label>
                <Form.Control
                  type="date"
                  placeholder="Enter To"
                  value={to}
                  onChange={(e) => {
                    setTo(e.target.value);
                    handlePageChange(1);
                  }}
                  min={from}
                />
              </div>
              <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
                <button
                  className="btn btn-danger "
                  onClick={() => {
                    setName("");
                    setemail("");
                    setcontact_no("");
                    setFrom("");
                    setTo("");
                    setDriverName("");
                    setBookingType("");
                    url.searchParams.delete("booking_id");
                    window.history.replaceState({}, "", url);
                    setBookingId("");
                    fetch();
                  }}
                >
                  Reset
                </button>
              </div>
              <div className="mb-3">
                {/* <button className="btn btn-success " onClick={HandleDownload}>
                  Download Excel
                </button> */}
              </div>
            </div>
          </div>
        </div>

        {/* <Add id={id} setId={setId} /> */}
        <div className="table-responsive">
          <div className="table_section theme_bg">
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>S. no.</th>
                    <th>ID</th>
                    <th>Driver Name</th>
                    <th>Driver Contact Number</th>
                    <th>Driver Email</th>
                    <th>Start Date</th>
                    <th>Drop Details </th>
                    <th>Booking Details </th>
                    <th>Booking Status </th>
                    <th>Ratings </th>
                  </tr>
                </thead>
                <tbody>
                  {country?.data?.data?.length > 0 ? (
                    country?.data.data?.map((val, index) => (
                      <tr key={index}>
                        <td>
                          {(country?.data?.current_page - 1) *
                            country?.data?.per_page +
                            index +
                            1}
                        </td>
                        <td>{val?.id || "-"}</td>
                        <td>{val?.Driver?.first_name || "-"}</td>
                        <td>{val?.Driver?.contact_no || "-"}</td>
                        <td>{val?.Driver?.email || "-"}</td>
                        <td>
                          {new Date(val?.start_date).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </td>

                        <td>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                              minWidth: "620px",
                            }}
                          >
                            {val?.ShareLocations?.map((loc, index) => {
                              const isFirst = index === 0;
                              const isLast =
                                index === val.ShareLocations.length - 1;

                              const color = isFirst
                                ? "#28a745"
                                : isLast
                                ? "#dc3545"
                                : "#007bff";

                              const arrowColor = isFirst
                                ? "#28a745"
                                : isLast
                                ? "#dc3545"
                                : "#007bff";

                              return (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    gap: "20px",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  {/* ================= Location ================= */}
                                  <div
                                    style={{
                                      width: "300px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* Arrow */}
                                    <div
                                      style={{
                                        color,
                                        fontSize: "26px",
                                        fontWeight: "bold",
                                        lineHeight: 1,
                                        marginBottom: 5,
                                      }}
                                    >
                                      ↓
                                    </div>

                                    {/* Location */}
                                    <div
                                      style={{
                                        width: "300px",
                                        color,
                                        padding: "6px 10px",
                                        textAlign: "center",
                                        fontWeight:
                                          isFirst || isLast ? 600 : 400,
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {loc.location}
                                    </div>

                                    {/* Arrow after location (except last) */}
                                    {!isLast && (
                                      <div
                                        style={{
                                          color:
                                            index ===
                                            val.ShareLocations.length - 2
                                              ? "#dc3545"
                                              : isFirst
                                              ? "#28a745"
                                              : "#007bff",
                                          fontSize: "26px",
                                          fontWeight: "bold",
                                          lineHeight: 1,
                                          marginTop: 5,
                                        }}
                                      >
                                        ↓
                                      </div>
                                    )}
                                  </div>

                                  {/* ================= Status ================= */}
                                  <div
                                    style={{
                                      width: "300px",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* Arrow Before Status */}
                                    <div
                                      style={{
                                        color: arrowColor,
                                        fontSize: "26px",
                                        fontWeight: "bold",
                                        lineHeight: 1,
                                        marginBottom: 6,
                                      }}
                                    >
                                      ↓
                                    </div>

                                    {/* Status */}
                                    <div
                                      style={{
                                        width: "100px",
                                        background: color,
                                        color: "#fff",
                                        padding: "6px 10px",
                                        borderRadius: 8,
                                        textAlign: "center",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {isFirst ? "Start" : `₹${loc.rate}`}
                                    </div>

                                    {/* Arrow After Status */}
                                    {!isLast && (
                                      <div
                                        style={{
                                          color:
                                            index ===
                                            val.ShareLocations.length - 2
                                              ? "#dc3545"
                                              : "#007bff",
                                          fontSize: "26px",
                                          fontWeight: "bold",
                                          lineHeight: 1,
                                          marginTop: 6,
                                        }}
                                      >
                                        ↓
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </td>

                        <td>
                          <Button
                            className="btn view-btn btn-sm"
                            onClick={() => {
                              setBookingDetails(val);
                              setDetailModalShow(true);
                            }}
                          >
                            {/* View */}
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                        </td>

                        <td>
                          <Badge>{val?.BookingStatus?.name}</Badge>
                        </td>
                        <td>
                          <Button
                            className="btn view-btn btn-sm"
                            onClick={() => {
                              setRating(val?.Ratings);
                              setRatingShow(true);
                            }}
                          >
                            {/* View */}
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Pagination_Holder
          onPageChange={country?.data?.current_page}
          totalPages={country?.data?.total_pages}
          handlePageChange={handlePageChange}
        />
      </section>
      <View_Share_Booking_Modal
        show={detailModalShow}
        bookingdetails={bookingdetails}
        onHide={() => setDetailModalShow(false)}
      />
      <View_Share_Taxi_Rating_Model
        show={ratingShow}
        rating={rating}
        name={"Share Booking"}
        onHide={() => setRatingShow(false)}
      />
      <View_Modal
        show={modalShow}
        dropdetails={dropdetails}
        onHide={() => setModalShow(false)}
      />
      <View_img_Modal
        show={modalImageShow}
        image={image}
        onHide={() => setModalImageShow(false)}
      />
    </>
  );
};

export default Booking;
